/*
 * ns-product-details-drawer — behaviour for the Product Details drawer
 * (snippets/custom-popup-content.liquid). Loaded once by fa-main-product.
 *
 * One accordion open at a time within a drawer: opening one closes its open
 * siblings in the same `.custom-popup__accordions` list. The first accordion
 * renders open in Liquid.
 *
 * Same mechanism as the buy box's exclusive accordions
 * (snippets/accordion-product-info.liquid, fa_buybox branch): the sibling is
 * closed through the AccordionDisclosure `open` PROPERTY, which runs the
 * element's animated `_transition` and keeps `aria-expanded` and its internal
 * `_open` flag in sync. The native `name` attribute is not used because
 * AccordionDisclosure tracks its own `_open` flag, and a browser-forced close
 * would leave that flag stale.
 *
 * Two triggers, both on the document so drawers whose markup arrives after
 * load are covered:
 * - `click` on a summary, in the bubble phase, so AccordionDisclosure's own
 *   summary handler has already flipped `open`. This catches reopening an
 *   accordion while its close animation is still running: the `open`
 *   attribute never leaves, so no `toggle` event fires.
 * - `toggle`, in the capture phase (it does not bubble), for accordions
 *   opened without a click, such as theme-editor block selection.
 *
 * The close button is the theme's `close-button` element, so it needs no
 * script here.
 */
(function () {
  if (window.__nsProductDetailsDrawer) return;
  window.__nsProductDetailsDrawer = true;

  function closeSiblings(details) {
    if (!details || !details.classList.contains('custom-popup__accordion') || !details.open) return;

    var list = details.parentElement;
    if (!list || !list.classList.contains('custom-popup__accordions')) return;

    list.querySelectorAll(':scope > details.custom-popup__accordion').forEach(function (sibling) {
      if (sibling !== details && sibling.open) sibling.open = false;
    });
  }

  document.addEventListener('click', function (event) {
    var summary = event.target.closest && event.target.closest('summary');
    if (!summary || !summary.parentElement || summary.parentElement.tagName !== 'DETAILS') return;
    closeSiblings(summary.parentElement);
  });

  document.addEventListener(
    'toggle',
    function (event) {
      var details = event.target;
      if (!details || details.tagName !== 'DETAILS' || !details.hasAttribute('open')) return;
      closeSiblings(details);
    },
    true
  );
})();
